<template>
  <div class="home">

    <div class="home_main">
      <div id="app" ref="appRef">
        <div>
          <nav-bar :navigationIndex="0" @customEvent="parentMethod" />
        </div>
        <div class="home_main_first">
          <div class="column_title_box flex_center flex_column w_1280 no-select">
            <div class="title_name">根据自身需求，选择适合您的方式</div>
            <div class="title_txt">请登录后获取适合您的方案</div>
          </div>

          <div class="first_main flex_between w_1280">
            <div class="first_main_left cursor"
              :class="{ 'select_first_main_left color_fff': retrieverIndex != 1, 'custom_tada': isAnimating && retrieverIndex != 1 }"
              @animationend="handleAnimationEnd" @click="handleFirstEnter(1)" @mouseleave="handleFirstLeave">
              <div class="first_left_title flex_between">
                <div class="flex">产品检索器 <div class="flex" :class="retrieverIndex != 1 ? 'way_box' : 'select_way_box'">
                    <img v-if="retrieverIndex != 1" src="@/assets/images/searchLogo01.png" alt="" />
                    <img v-else src="@/assets/images/searchLogo02.png" alt="" />
                    按指标甄选产品
                  </div>
                </div> <span class="color_238AFE fz16" v-if="retrieverIndex == 1 && !isLogin">登录了解更多</span>
                <!-- <span
                  class="color_fff fz16"
                  style="padding:5px 10px;background-color : rgba(255, 255, 255, 0.6);border-radius: 3px;"
                  :class="{ 'animate__animated animate__tada': isAnimating && retrieverIndex != 1 }"
                  v-if="retrieverIndex != 1">点击展开检索器</span> -->
              </div>
              <div class="fz20" v-if="retrieverIndex == 1">
                根据您的产品指标需求，为您提供准确的产品。若不满足您的定制化需求，可通过混配计算器为您生成适合您的石油焦混配方案
              </div>
              <div class="target_list_two flex" v-if="retrieverIndex == 1">
                <div class="target_box">
                  <div class="target_name fz18 flex">
                    <img src="@/assets/images/retrieverIcon1.png" alt="" />硫
                  </div>
                  <!-- <div class="target_input flex">
                    <input type="text" /> <span class="fz18 color_666">%</span>
                  </div> -->
                  <div class="target_input2 flex">
                    <input type="text" placeholder="请输入" />
                    <span class="separator">~</span> <!-- 新增 ~ 符号的包裹元素 -->
                    <input type="text" placeholder="请输入" />
                    <span class="unit_box fz18 color_238AFE">%</span>
                  </div>
                </div>
                <div class="target_box">
                  <div class="target_name fz18 flex">
                    <img src="@/assets/images/retrieverIcon2.png" alt="" />钒
                  </div>
                  <div class="target_input2 flex">
                    <input type="text" placeholder="请输入" />
                    <span class="separator">~</span> <!-- 新增 ~ 符号的包裹元素 -->
                    <input type="text" placeholder="请输入" />
                    <span class="unit_box fz18 color_238AFE">%</span>
                  </div>
                </div>
                <div class="target_box">
                  <div class="target_name fz18 flex">
                    <img src="@/assets/images/retrieverIcon3.png" alt="" />真密度
                  </div>
                  <div class="target_input2 flex">
                    <input type="text" placeholder="请输入" />
                    <span class="separator">~</span> <!-- 新增 ~ 符号的包裹元素 -->
                    <input type="text" placeholder="请输入" />
                    <span class="unit_box fz18 color_238AFE">%</span>
                  </div>
                </div>

                <div class="fz16" style="margin-bottom: 32px;">
                  更多指标 ...
                </div>
              </div>

              <div class="search_btn fz20 color_fff flex_center cursor" v-if="retrieverIndex == 1"
                @click="goPage('/dailyJiaoYi')">
                前往检索
              </div>

              <div class="fz18" v-if="retrieverIndex == 2">
                深入剖析您的产品指标需求，为您提供精准适配的产品
              </div>
              <div class="fz18" v-if="retrieverIndex == 2">
                若现有产品不满足您的定制化需求，可通过混配计算器，为您生成适合您的石油焦混配方案
              </div>
              <div class="first_right_img" v-if="retrieverIndex == 2">
              </div>
              <div class="center cursor" v-if="retrieverIndex == 2" @click="goPage('/dailyJiaoYi')">
                点击了解更多 >
              </div>
            </div>
            <div class=" cursor no-select"
              :class="{ 'first_main_right color_fff': retrieverIndex != 2, 'select_first_main_right': retrieverIndex == 2, 'custom_tada': isAnimating && retrieverIndex != 2 }"
              @animationend="handleAnimationEnd" @click="handleFirstEnter(2)" @mouseleave="handleFirstLeave">
              <div class="first_left_title flex_between">
                <div class="flex">混配计算器 <div class="flex" :class="retrieverIndex != 2 ? 'way_box' : 'select_way_box'">
                    <img v-if="retrieverIndex != 2" src="@/assets/images/searchLogo01.png" alt="" />
                    <img v-else src="@/assets/images/searchLogo02.png" alt="" />
                    依需求定制方案
                  </div>
                </div> <span class="color_238AFE fz16" v-if="retrieverIndex == 2 && !isLogin">登录了解更多</span>
                <!-- <span
                  class="color_238AFE fz16"
                  style="padding:5px 10px;background-color : rgba(255, 255, 255, 0.6);border-radius: 3px;"
                  :class="{ 'animate__animated animate__tada': isAnimating && retrieverIndex != 2 }"
                  v-if="retrieverIndex != 2">点击展开计算器</span> -->
              </div>
              <div class="fz20" v-if="retrieverIndex == 2">
                可以根据您的产品指标需求，从全网挂单、炼厂生产工艺历史指标和历史成交数据为您生成适合您的石油焦混配方案
              </div>
              <div class="target_list flex" v-if="retrieverIndex == 2">
                <div class="target_box">
                  <div class="target_name fz18 flex">
                    <img src="@/assets/images/retrieverIcon1.png" alt="" />硫
                  </div>
                  <div class="target_input flex">
                    <input type="text" /> <span class="fz18 color_666">%</span>
                  </div>
                </div>
                <div class="target_box">
                  <div class="target_name fz18 flex">
                    <img src="@/assets/images/retrieverIcon2.png" alt="" />钒
                  </div>
                  <div class="target_input flex">
                    <input type="text" /> <span class="fz18 color_666">%</span>
                  </div>
                </div>
                <div class="target_box">
                  <div class="target_name fz18 flex">
                    <img src="@/assets/images/retrieverIcon3.png" alt="" />真密度
                  </div>
                  <div class="target_input flex">
                    <input type="text" /> <span class="fz18 color_666">%</span>
                  </div>
                </div>
                <div class="target_box">
                  <div class="target_name fz18 flex">
                    <img src="@/assets/images/retrieverIcon4.png" alt="" />水分
                  </div>
                  <div class="target_input flex">
                    <input type="text" /> <span class="fz18 color_666">%</span>
                  </div>
                </div>
                <div class="target_box fz16" style="margin-top: 20px;">
                  更多指标 ...
                </div>
              </div>

              <div class="search_btn fz20 color_fff flex_center cursor" v-if="retrieverIndex == 2"
                @click="goPage('/dailyJiaoYi')">
                前往检索
              </div>
              <div class="fz18" v-if="retrieverIndex == 1">
                根据您的产品指标需求，从全网挂单、炼厂生产工艺历史指标和历史成交数据中进行分析
              </div>
              <div class="fz18" v-if="retrieverIndex == 1">
                综合多源数据深度挖掘与精准测算，为您生成适合您的石油焦混配方案
              </div>
              <div class="first_right_img" v-if="retrieverIndex == 1">
              </div>
              <div class="center cursor" v-if="retrieverIndex == 1" @click="goPage('/dailyJiaoYi')">
                点击了解更多 >
              </div>
            </div>
          </div>
        </div>

        <div class="home_main_two">
          <div class=" w_1280">
            <div class="column_title_box flex_center flex_column color_fff no-select">
              <div class="title_name">价格指数</div>
              <div class="title_txt">PRICE INDEX</div>
            </div>

            <div>
              <div class="flex_between">
                <div class="two_nav_list flex" v-if="typeList.length > 0">
                  <div class="mr20 flex_center cursor"
                    :class="priceIndex == item.id ? 'select_two_nav_box' : 'two_nav_box'"
                    @click="getPriceIndex(item.id)" v-for="item in typeList" :key="item.id">{{ item.name }}</div>
                </div>
                <div class="cursor graph_btn flex_center" @click="goPage('/dailyJiaoYi')">查看全部</div>
              </div>

              <div class="flex_between">
                <div class="two_left_list color_fff fz22" @mouseenter="listMouseEnter" @mouseleave="listMouseLeave">
                  <div class="two_left_one flex bg_05215C">
                    <div class="two_list_box_one flex_center border_right">日期</div>
                    <div class="two_list_box_two flex_center border_right">指标</div>
                    <div class="two_list_box_three flex_center">涨跌</div>
                  </div>
                  <div class="two_left_two_list" v-if="exponentLeftList.length > 0">
                    <div class="two_left_two flex bg_0E2765" :class="index % 2 == 0 ? 'bg_143177' : 'bg_02174E'"
                      v-for="(item, index) in exponentLeftList" :key="item.id">
                      <div class="two_list_box_one flex_center border_right text_overflow">{{ item.createTime }}</div>
                      <div class="two_list_box_two flex_center border_right text_overflow">
                        <marquee loop="infinite" behavior="scroll" scrollamount="5" class="flex"><span class="mr20">{{
                          item.propertyValue }}</span> <span class="mr20">{{ item.propertyValue }}</span><span
                            class="mr20">{{ item.propertyValue }}</span><span class="mr20">{{ item.propertyValue
                            }}</span><span class="mr20">{{ item.propertyValue }}</span></marquee>
                      </div>
                      <div class="two_list_box_three text_overflow"
                        :class="['market_six_D10000', 'market_six_09A601', ''][item.rateFlag]">{{ item.dealMoneySingle
                        }}
                        <img v-if="item.rateFlag == 0" src="@/assets/images/riseIcon.png" alt="" />
                        <img v-if="item.rateFlag == 1" src="@/assets/images/declineIcon.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="two_left_two_list flex_center" style="width:100%;height:100%;" v-else><img
                      src="@/assets/images/noData.png" alt="" />
                  </div>

                </div>
                <div class="two_right_list">
                  <echarts ref="echartsRef" v-if="exponentRightList.seriesList.length > 0"></echarts>
                  <div class="two_left_two_list flex_center" style="width:100%;height:100%;" v-else><img
                      src="@/assets/images/noData.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="home_main_three">
          <div class="column_title_box flex_center flex_column w_1280 no-select">
            <div class="title_name">产业服务</div>
            <div class="title_txt">INDUSTRIAL SERVICE</div>
          </div>
          <div class="flex_end w_1280">
            <div class="cursor graph_btn_2 flex_center">查看全部</div>
          </div>
          <div class="w_1280 three_list cursor flex_between color_fff">
            <div class="three_box three_box_bg_one" :class="serviceIndex == 1 ? 'select_three_box' : ''"
              @mouseenter="handleMouseEnter(1)" @mouseleave="handleMouseLeave">
              <div class="box_main">
                <div class="three_box_logo"><img src="@/assets/images/serviceLogo1.png" alt="" /></div>
                <div class="fz24">行长驾驶舱</div>
                <div class="three_box_line">
                </div>
                <div class="multi_line_ellipsis2 three_box_text"
                  :class="serviceIndex == 1 ? 'select_three_box_text' : ''">
                  焦易数科行长驾驶舱打造银企数字化协同中枢，基于数字工厂实时生产经营数据与银行风控模型，为企业提供高效融资对接服务。</div>
                <div class="three_box_btn flex_center fz18 cursor" v-if="serviceIndex == 1" @click="goServiceDetail(1)">
                  查看详情
                </div>
                <div class="three_box_img cursor" v-else @click="goServiceDetail(1)">
                  <img src="@/assets/images/slide_next_two.svg" alt="" />
                </div>
              </div>

              <div class="mask"></div>
            </div>
            <div class="three_box three_box_bg_two" :class="serviceIndex == 2 ? 'select_three_box' : ''"
              @mouseenter="handleMouseEnter(2)" @mouseleave="handleMouseLeave">
              <div class="mask"></div>
              <div class="box_main">
                <div class="three_box_logo"><img src="@/assets/images/serviceLogo2.png" alt="" /></div>
                <div class="fz24">劳保服务</div>
                <div class="three_box_line">
                </div>
                <div class="multi_line_ellipsis2 three_box_text"
                  :class="serviceIndex == 2 ? 'select_three_box_text' : ''">
                  聚焦企业安全生产与员工健康管理，提供劳保用品智能采购、安全培训定制、风险预警系统等一站式服务。</div>
                <div class="three_box_btn flex_center fz18 cursor" v-if="serviceIndex == 2" @click="goServiceDetail(2)">
                  查看详情
                </div>
                <div class="three_box_img cursor" v-else @click="goServiceDetail(2)">
                  <img src="@/assets/images/slide_next_two.svg" alt="" />
                </div>
              </div>
            </div>
            <div class="three_box three_box_bg_three" :class="serviceIndex == 3 ? 'select_three_box' : ''"
              @mouseenter="handleMouseEnter(3)" @mouseleave="handleMouseLeave">
              <div class="mask"></div>
              <div class="box_main">
                <div class="three_box_logo"><img src="@/assets/images/serviceLogo3.png" alt="" /></div>
                <div class="fz24">物流服务</div>
                <div class="three_box_line">
                </div>
                <div class="multi_line_ellipsis2 three_box_text"
                  :class="serviceIndex == 3 ? 'select_three_box_text' : ''">
                  依托旗下“焦好运网络货运平台”，焦易数科通过智能算法实现运输资源高效匹配与路径优化，为客户提供透明化、可视化的物流解决方案。</div>
                <div class="three_box_btn flex_center fz18 cursor" v-if="serviceIndex == 3" @click="goServiceDetail(3)">
                  查看详情
                </div>
                <div class="three_box_img cursor" v-else @click="goServiceDetail(3)">
                  <img src="@/assets/images/slide_next_two.svg" alt="" />
                </div>
              </div>
            </div>
            <div class="three_box three_box_bg_four" :class="serviceIndex == 4 ? 'select_three_box' : ''"
              @mouseenter="handleMouseEnter(4)" @mouseleave="handleMouseLeave">
              <div class="mask"></div>
              <div class="box_main">
                <div class="three_box_logo"><img src="@/assets/images/serviceLogo4.png" alt="" /></div>
                <div class="fz24">焦真质检</div>
                <div class="three_box_line">
                </div>
                <div class="multi_line_ellipsis2 three_box_text"
                  :class="serviceIndex == 4 ? 'select_three_box_text' : ''">
                  针对石油炼化、负极材料及电解铝行业核心原料质量控制需求，焦易数科提供石油焦、煅烧焦专业化检测服务。</div>
                <div class="three_box_btn flex_center fz18 cursor" v-if="serviceIndex == 4" @click="goServiceDetail(4)">
                  查看详情
                </div>
                <div class="three_box_img cursor" v-else @click="goServiceDetail(4)">
                  <img src="@/assets/images/slide_next_two.svg" alt="" />
                </div>
              </div>
            </div>
            <div class="three_box three_box_bg_five" :class="serviceIndex == 5 ? 'select_three_box' : ''"
              @mouseenter="handleMouseEnter(5)" @mouseleave="handleMouseLeave">
              <div class="mask"></div>
              <div class="box_main">
                <div class="three_box_logo"><img src="@/assets/images/serviceLogo5.png" alt="" /></div>
                <div class="fz24">数字工厂</div>
                <div class="three_box_line">
                </div>
                <div class="multi_line_ellipsis2 three_box_text"
                  :class="serviceIndex == 5 ? 'select_three_box_text' : ''">
                  为满足工厂智能化生产，安全预警等需求，焦易数科基于工厂生产场景，打造多款数字化产品，包含订单排产、工艺分析、智慧园区、质检管理、人员定位、双预防系统、能源管控，帮助工厂实现数字化升级。</div>
                <div class="three_box_btn flex_center fz18 cursor" v-if="serviceIndex == 5" @click="goServiceDetail(5)">
                  查看详情
                </div>
                <div class="three_box_img cursor" v-else @click="goServiceDetail(5)">
                  <img src="@/assets/images/slide_next_two.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="home_main_four">
          <div class=" w_1280">
            <div class="column_title_box flex_center flex_column color_fff no-select">
              <div class="title_name">产业新闻</div>
              <div class="title_txt">INDUSTRY NEWS</div>
            </div>
            <div class="flex_end">
              <div class="cursor graph_btn flex_center">查看全部</div>
            </div>
          </div>

          <div class="news_list flex_between w_1280">
            <div class="news_box cursor" v-for="item in industryNewsInfo" :key="item.id" @click="goDetail(item)"
              @mouseenter="newMouseEnter(item.id)" @mouseleave="newMouseLeave">
              <div class="news_title_box flex_between color_fff">
                <div class="news_title text_overflow">{{ item.title }}</div>
                <div>
                  <el-icon>
                    <Right />
                  </el-icon>
                </div>
              </div>
              <div class="news_text_box color_fff">
                <div :class="newsId == item.id ? 'new_line_select' : 'new_line'"></div>
                <div class="news_content multi_line_ellipsis3">
                  {{ item.introduce }}
                </div>
                <div class="news_img">
                  <img :src="item.imgPath" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-bar></bottom-bar>
  </div>
</template>

<script>
import { topInfo, listGlobal, homeArticleList, productTypeList, exponentLeft, exponentRight } from "@/utils/homeApi";
import echarts from './components/echarts.vue';
import 'animate.css';

export default {
  name: "HomePage",
  components: {
    echarts,
  },
  data() {
    return {
      topInfo: {},

      retrieverIndex: 1,
      currentScreen: 0, // 当前所在屏幕的索引
      isScrolling: false, // 标记是否正在滚动
      scrollDuration: 1000, // 滚动动画的持续时间（毫秒）

      typeList: [],
      exponentLeftList: [],
      exponentRightList: {
        seriesList: [],
      },

      industryNewsInfo: {},
      newsId: "",

      priceIndex: 1,

      serviceIndex: 1,
      serviceList: [
        {
          id: 1,
          name: '行长驾驶舱',
          content: '焦易数科行长驾驶舱打造银企数字化协同中枢，基于数字工厂实时生产经营数据与银行风控模型，为企业提供高效融资对接服务。',
        },
        {
          id: 2,
          name: '劳保服务',
          content: '聚焦企业安全生产与员工健康管理，提供劳保用品智能采购、安全培训定制、风险预警系统等一站式服务。',
        },
        {
          id: 3,
          name: '物流服务',
          content: '依托旗下“焦好运网络货运平台”，焦易数科通过智能算法实现运输资源高效匹配与路径优化，为客户提供透明化、可视化的物流解决方案。',
        },
        {
          id: 4,
          name: '焦真质检',
          content: '针对石油炼化、负极材料及电解铝行业核心原料质量控制需求，焦易数科提供石油焦、煅烧焦专业化检测服务。',
        },
        {
          id: 5,
          name: '数字工厂',
          content: '为满足工厂智能化生产，安全预警等需求，焦易数科基于工厂生产场景，打造多款数字化产品，包含订单排产、工艺分析、智慧园区、质检管理、人员定位、双预防系统、能源管控，帮助工厂实现数字化升级。',
        },
      ],

      priceIndexMouse: 0,
      isLogin: true,
      isAnimating: false,
      animationInterval: null
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    // 监听滚轮事件
    window.addEventListener("wheel", this.handleWheel);

    this.getBasicInfo();

    this.getProductTypeList();

    this.startAnimationInterval();
  },
  beforeUnmount() {
    // 组件销毁前移除滚轮事件监听器
    window.removeEventListener("wheel", this.handleWheel);
    clearInterval(this.animationInterval);
  },
  methods: {
    startAnimationInterval() {
      this.animationInterval = setInterval(() => {
        this.isAnimating = true;
      }, 5000); // 每 3 秒执行一次动画
    },
    handleAnimationEnd() {
      this.isAnimating = false;
    },
    listMouseEnter() {
      this.priceIndexMouse = 1;
    },
    listMouseLeave() {
      this.priceIndexMouse = 0;
    },
    handleFirstEnter(index) {
      this.retrieverIndex = index;
    },
    handleFirstLeave() {
      // this.retrieverIndex = 1;
    },
    // 父组件的方法
    parentMethod(type) {
      console.log('父组件方法被调用', type);
      this.isLogin = type;
      // 登录后重新调用接口
      this.getBasicInfo();
      this.getProductTypeList();
    },
    getPriceIndex(type) {
      this.priceIndex = type;
      this.getExponentLeft();
    },
    // 鼠标移入事件处理函数
    handleMouseEnter(index) {
      this.serviceIndex = index;
    },
    // 鼠标移出事件处理函数
    handleMouseLeave() {
      // this.serviceIndex = 1;
    },
    // 查看服务详情
    goServiceDetail(index) {
      this.$router.push({
        path: '/serviceDetail',
        query: {
          detail: JSON.stringify(this.serviceList[index - 1]),
        }
      });
    },
    handleWheel(event) {
      if (this.priceIndexMouse == 1) {
        return
      }
      // 防止在滚动动画进行时重复触发
      if (this.isScrolling) return;

      // 阻止默认的滚动行为
      event.preventDefault();

      const delta = Math.sign(event.deltaY);
      const screens = this.$refs.appRef.children;
      const totalScreens = screens.length;

      if (delta > 0 && this.currentScreen < totalScreens - 1) {
        // 向下滚动
        this.currentScreen++;
      } else if (delta < 0 && this.currentScreen > 0) {
        // 向上滚动
        this.currentScreen--;
      } else {
        return;
      }

      // 开始滚动动画
      this.scrollToScreen(this.currentScreen);
    },
    scrollToScreen(index) {
      this.isScrolling = true;

      const screens = this.$refs.appRef.children;
      const targetElement = screens[index];
      const startPosition = window.pageYOffset;
      const targetPosition = targetElement.offsetTop;
      const startTime = performance.now();

      const scrollAnimation = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        if (elapsedTime < this.scrollDuration) {
          const progress = elapsedTime / this.scrollDuration;
          const newPosition =
            startPosition + (targetPosition - startPosition) * progress;
          window.scrollTo(0, newPosition);
          requestAnimationFrame(scrollAnimation);
        } else {
          window.scrollTo(0, targetPosition);
          this.isScrolling = false;
        }
      };

      requestAnimationFrame(scrollAnimation);
    },

    // 首页基本信息列表
    async getBasicInfo() {
      let res1 = await topInfo();
      if (res1.code == 200) {
        this.topInfo = res1.data;
      }

      let res2 = await listGlobal();
      if (res2.code == 200) {
        this.listGlobalInfo = res1.data;
      }

      let res3 = await homeArticleList();
      if (res3.code == 200) {
        this.industryNewsInfo = res3.data;
      }
    },

    async getProductTypeList() {
      let res = await productTypeList();
      if (res.code == 200) {
        this.typeList = res.data;
        this.priceIndex = res.data[0].id;
        this.getExponentLeft();
      }
    },

    async getExponentLeft() {
      let res = await exponentLeft({
        productTypeId: this.priceIndex,
        limit: 50,
      })

      if (res.code == 200) {
        this.exponentLeftList = res.data.data;
      }

      let res2 = await exponentRight({
        productTypeId: this.priceIndex,
        minusDay: 10,
      });

      if (res2.code == 200) {
        this.exponentRightList = res2.data;
        if (this.exponentRightList.seriesList.length > 0) {
          setTimeout(() => {
            this.$refs.echartsRef.addChart(this.exponentRightList)
          }, 500)
        }
      }
    },

    // 新闻切换
    newMouseEnter(id) {
      this.newsId = id;
    },
    newMouseLeave() {
      this.newsId = 0;
    },

    // 查看新闻详情
    goDetail(item) {
      this.$router.push({
        path: '/newsDetails',
        query: {
          id: item.id,
        }
      });
    },

    // 时间处理
    filterTimeYear(time) {
      return time.split(" ")[0].split("-")[0];
    },

    filterTimeMonth(time) {
      return time.split(" ")[0].split("-")[1];
    },

    filterTimeDay(time) {
      return time.split(" ")[0].split("-")[2];
    },
    // 跳转页面
    goPage(path) {
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.column_title_box {
  padding-top: 150px;
}

.title_name {
  font-size: 48px;
  font-weight: 600;
  letter-spacing: 5px;
}

.title_txt {
  font-size: 20px;
  font-weight: bold;
}

.graph_btn {
  // margin-top: 150px;
  width: 163px;
  height: 49px;
  border-radius: 8px;
  border: 2px solid #ffffff;
  font-size: 20px;
  color: #ffffff;
}

.graph_btn_2 {
  // margin-top: 150px;
  width: 163px;
  height: 49px;
  border-radius: 8px;
  border: 2px solid #2389fc;
  font-size: 20px;
  color: #2389fc;
}

// 根据自身需求，选择适合您的方式
.home_main_first {
  height: 100vh;
  background: url("@/assets/images/bg02.png") no-repeat center;
  background-size: cover;
}

.first_main {
  margin-top: 50px;
}

.first_main_left {
  width: 707px;
  height: 463px;
  background: #FFFFFF;
  box-shadow: 6px 6px 17px 1px rgba(0, 74, 157, 0.1);
  border-radius: 8px;
  padding: 47px 45px 57px 57px;
  background: url("@/assets/images/search01.png") no-repeat center;
  background-size: 100% 100%;
  transition: width 0.5s ease;
}

.select_first_main_left {
  width: 363px;
  height: 490px;
  background: url("@/assets/images/search03.png") no-repeat center;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 47px 37px 30px 50px;
}


.first_left_title {
  font-size: 34px;
  margin-bottom: 27px;
}

.way_box {
  color: #0d7aff;
  font-size: 20px;
  border: 1px solid #0d7aff;
  border-radius: 8px;
  padding: 5px 10px;
  margin-left: 10px;
  background-color: #fff;

  img {
    width: 20px;
    height: 20px;
    object-fit: cover;
    margin-right: 5px;
  }
}

.select_way_box {
  color: #f15a38;
  font-size: 20px;
  border: 1px solid #f15a38;
  border-radius: 8px;
  padding: 5px 10px;
  margin-left: 10px;

  img {
    width: 20px;
    height: 20px;
    object-fit: cover;
    margin-right: 5px;
  }
}

.target_list_two {
  // width: 600px;
  flex-wrap: wrap;
  margin-top: 40px;
}

.target_list {
  width: 500px;
  flex-wrap: wrap;
  margin-top: 40px;
}

.target_box {
  margin-right: 51px;
  margin-bottom: 57px;
}

.target_name img {
  width: 22px;
  height: 22px;
  object-fit: cover;
}

.target_input {
  width: 111px;
  height: 31px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #238AFE;
  margin-top: 5px;
}

.target_input input {
  width: 70px;
  height: 80%;
  margin-top: 5px;
  margin: 0;
  padding: 0;
  padding-left: 10px;
  margin-right: 10px;
  border: none;
  outline: none;
}

.target_input2 {
  padding: 5px 9px 5px 0px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #238AFE;
  margin-top: 5px;
}

.target_input2 input {
  text-align: center;
  width: 60px;
  height: 20px;
  margin-top: 5px;
  margin: 0;
  padding: 0;
  padding-left: 5px;
  border: none;
  outline: none;
  color: #238AFE;
}

.unit_box {
  width: 90px;
  text-align: center;
}

.search_btn {
  width: 281px;
  height: 54px;
  background: #238AFE;
  border-radius: 4px;
}

.first_main_right {
  width: 363px;
  height: 490px;
  box-shadow: 0px 9px 17px 1px rgba(0, 74, 157, 0.19);
  border-radius: 8px;
  padding: 47px 37px 30px 50px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background: url("@/assets/images/search02.png") no-repeat center;
  background-size: 100% 100%;
  transition: width 0.5s ease;
}

.select_first_main_right {
  width: 707px;
  height: 463px;
  background: url("@/assets/images/search04.png") no-repeat center;
  background-size: 100% 100%;
  // display: block;
  padding: 47px 45px 57px 57px;
}

.first_right_img {
  width: 290px;
  height: 220px;
  margin: 0 auto;
}

// 价格指数
.home_main_two {
  height: 100vh;
  background: url("@/assets/images/home03.png") no-repeat center;
  background-size: cover;
}

.two_nav_list {
  margin-top: 25px;
  margin-bottom: 28px;
}

.two_nav_box {
  padding: 10px 16px;
  border-radius: 4px;
  border: 2px solid rgba(0, 252, 253, 0);
  font-size: 24px;
  color: #FFFFFF;
}

.select_two_nav_box {
  padding: 10px 16px;
  border-radius: 4px;
  border: 2px solid #00FCFD;
  font-size: 24px;
  color: #00FCFD;
}

.two_left_list {
  width: 435px;
  height: 537px;
  border-radius: 10px;
}

.border_right {
  border-right: 1px solid #999999;
}

.two_left_one {
  height: 46px;
  border-radius: 10px 10px 0px 0px;
}

.two_left_two {
  height: 46px;
}

.two_list_box_one {
  width: 111px;
  height: 100%;
}

.two_list_box_two {
  width: 198px;
  height: 100%;
}

.two_list_box_three {
  padding-left: 8px;
  width: 113px;
  height: 100%;
  display: flex;
  align-items: center;
}

.two_list_box_three img {
  width: 14px;
  height: 18px;
  margin-left: 5px;
}


.market_six_D10000 {
  color: #D10000;
}

.market_six_09A601 {
  color: #09A601;
}

.two_left_two_list {
  height: 491px;
  border-radius: 0px 0px 10px 10px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none; // 滚动条隐藏
  }
}

.two_right_list {
  width: 825px;
  height: 533px;
  border-radius: 10px;
  background: url("@/assets/images/echartsBg.png") no-repeat center;
  background-size: 100% 100%;
}

// 产业服务
.home_main_three {
  height: 100vh;
  background: url("@/assets/images/bg04.png") no-repeat center;
  background-size: cover;
}

.three_list {
  margin-top: 40px;
}

.three_box {
  position: relative;
  width: 195px;
  height: 343px;
  border-radius: 4px;
  padding-left: 33px;
  padding-top: 190px;
  transition: width 0.5s ease;
  /* 添加过渡效果，让宽度变化持续 0.5 秒 */
}

.box_main {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  padding-left: 33px;
  padding-top: 190px;
  border-radius: 4px;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #042170;
  /* 黑色半透明遮罩 */
  opacity: 0.52;
  border-radius: 4px;
}

.three_box_bg_one {
  background: url("@/assets/images/serviceBg1.png") no-repeat left;
  background-size: cover;
}

.three_box_bg_two {
  background: url("@/assets/images/serviceBg2.png") no-repeat left;
  background-size: cover;
}

.three_box_bg_three {
  background: url("@/assets/images/serviceBg3.png") no-repeat left;
  background-size: cover;
}

.three_box_bg_four {
  background: url("@/assets/images/serviceBg4.png") no-repeat left;
  background-size: cover;
}

.three_box_bg_five {
  background: url("@/assets/images/serviceBg5.png") no-repeat left;
  background-size: cover;
}

.select_three_box {
  width: 325px;
}

.three_box_logo img {
  width: 29px;
  height: 29px;
  margin-bottom: 35px;
}

.three_box_line {
  width: 32px;
  height: 2px;
  background: #FFFFFF;
  margin: 16px 0;
}

.three_box_text {
  width: 126px;
  transition: width 0.5s ease;
}

.select_three_box_text {
  width: 243px;
}

.three_box_img img {
  width: 35px;
  height: 35px;
  margin-top: 69px;
}

.three_box_btn {
  width: 103px;
  height: 32px;
  background: #238AFE;
  border-radius: 3px;
  margin-top: 69px;
}

// 产业新闻
.home_main_four {
  height: 100vh;
  background: url("@/assets/images/bg05.png") no-repeat center;
  background-size: cover;
}

.news_list {
  margin-top: 65px;
}

.news_box {
  width: 414px;
}

.news_title_box {
  border-bottom: 2px solid #FFFFFF;
  padding-bottom: 36px;
}

.news_title {
  width: 300px;
  font-size: 20px;
}

.news_text_box {
  position: relative;
  margin-top: -2px;
}

.new_line {
  width: 67px;
  height: 2px;
  background: #fff;
  border-radius: 1px;
  margin-bottom: 30px;
}

.new_line_select {
  width: 67px;
  height: 2px;
  background: #238AFE;
  border-radius: 1px;
  margin-bottom: 30px;
}

.news_content {
  font-size: 16px;
  color: #BFBFBF;
}

.news_img {
  width: 100%;
  height: 282px;
  background: #FFFFFF;
  border-radius: 12px;
  margin-top: 37px;
}

.news_img img {
  width: 100%;
  height: 282px;
  background: #FFFFFF;
  border-radius: 12px;
  object-fit: cover;
}

/* 自定义 tada 动画 */
@keyframes custom-tada {
  0% {
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -1deg);
    /* 修改幅度 */
  }

  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, 1deg);
    /* 修改幅度 */
  }

  40%,
  60%,
  80% {
    transform: scale3d(1.05, 1.05, 1.05) rotate3d(0, 0, 1, -1deg);
    /* 修改幅度 */
  }

  100% {
    transform: scale3d(1, 1, 1);
  }
}

.custom_tada {
  animation-name: custom-tada;
  animation-duration: 1.5s;
  /* 修改动画时间 */
  animation-timing-function: ease-in-out;
}
</style>
